(function (Drupal) {
  Drupal.behaviors.ajaxAddJsFix = {
    attach: function () {
      if (Drupal.AjaxCommands.prototype.__fdcAjaxAddJsPatched) {
        return;
      }

      const originalAddJs = Drupal.AjaxCommands.prototype.add_js;

      Drupal.AjaxCommands.prototype.add_js = function (ajax, response, status) {
        const filteredData = (response.data || []).filter((script) => {
          const src = script.src || '';
          return !(
            src.includes('player.vimeo.com/api/player.js') ||
            src.includes('klaro/js/klaro_placeholder.js') ||
            script.type === 'text/plain'
          );
        });

        if (!filteredData.length) {
          return Promise.resolve();
        }

        return originalAddJs.call(this, ajax, { ...response, data: filteredData }, status);
      };

      Drupal.AjaxCommands.prototype.__fdcAjaxAddJsPatched = true;
    },
  };
})(Drupal);